export const TECHNICAL_UID = 'TlXaYM9HQ2UoeD5SzMRpUzi5oAk1';
